__turbopack_context__.v({
  "equivalentCard": "zT8MKq_equivalentCard",
  "equivalentCardAmount": "zT8MKq_equivalentCardAmount",
  "equivalentCardCopy": "zT8MKq_equivalentCardCopy",
  "equivalentCardTitle": "zT8MKq_equivalentCardTitle",
  "infoButton": "zT8MKq_infoButton",
});
